export interface BankTransaction {
    id: number;
    bank_id: number;
    contact_id: number;
    loan_id: number;
    insurance_id: number;
    insurance_loan_id: number;
    category: string;
    amount: number;
    principal: number;
    interest: number;
    late_fee: number | null;
    transaction_date: string | null;
    loan_amortization_number: number | null;
}

export const InitBankTransaction: BankTransaction = {
    id: 0,
    bank_id: 0,
    contact_id: 0,
    loan_id: 0,
    insurance_id: 0,
    insurance_loan_id: 0,
    category: '',
    amount: 0,
    principal: 0,
    interest: 0,
    late_fee: null,
    transaction_date: null,
    loan_amortization_number: null
}

